import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

/**
 * Frosted "Liquid Glass" pill meant to float over a media frame / chart.
 * The 45° fill (blue #3973DA → pink #F7BDE6 → peach #FFBD70) matches Figma's
 * "Liquid Glass – Regular – Small" material; its stops carry 0.7 alpha to
 * reproduce the design's 70%-opacity tint, so the `backdrop-filter` blur still
 * shows the media through the fill.
 */
const Pill = styled.div`
  label: overlayPillWithSpinner_pill;
  width: 100%;
  padding: 1.25rem 1.5rem;
  border-radius: 7.5rem;
  color: var(--color-white, #fff);
  background-image: linear-gradient(
    45deg,
    rgba(57, 115, 218, 0.6) 2.27%,
    rgba(247, 189, 230, 0.6) 61.54%,
    rgba(255, 189, 112, 0.6) 114.77%
  );
  backdrop-filter: blur(4px) saturate(180%);
  -webkit-backdrop-filter: blur(4px) saturate(180%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.32);
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.18),
    inset 1px 1px 0 rgba(255, 255, 255, 0.85),
    inset -1px -1px 0 rgba(0, 0, 0, 0.12);
`;

const Content = styled.div`
  label: overlayPillWithSpinner_content;
  display: flex;
  gap: 1em;
  align-items: flex-start;
  width: 100%;
`;

const LoaderWrap = styled.div`
  label: overlayPillWithSpinner_loaderWrap;
  width: 1.75rem;
  height: 1.75rem;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
`;

const Spinner = styled.img`
  label: overlayPillWithSpinner_spinner;
  display: block;
  width: 1.75rem;
  height: 1.75rem;
  animation: ${spin} 1.2s linear infinite;
`;

const TextBlock = styled.div`
  label: overlayPillWithSpinner_textBlock;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  justify-content: center;
  gap: 0.125rem;
  min-width: 0;
  padding-top: 0.125rem;
`;

const Text = styled.p`
  label: overlayPillWithSpinner_text;
  margin: 0;
  width: 100%;
  overflow: hidden;
  font-size: 1.25em;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: -0.02rem;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const TrailingSpacer = styled.div`
  label: overlayPillWithSpinner_trailingSpacer;
  width: 1.5rem;
  flex-shrink: 0;
  align-self: stretch;
`;

export const OverlayPillWithSpinnerStyled = {
  Pill,
  Content,
  LoaderWrap,
  Spinner,
  TextBlock,
  Text,
  TrailingSpacer
};
